export const colors = {
  primary: '#009640',
}
